import { render, staticRenderFns } from "./ThreatActorProfile.vue?vue&type=template&id=798adb6e&scoped=true"
import script from "./ThreatActorProfile.vue?vue&type=script&lang=js"
export * from "./ThreatActorProfile.vue?vue&type=script&lang=js"
import style0 from "./ThreatActorProfile.vue?vue&type=style&index=0&id=798adb6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798adb6e",
  null
  
)

export default component.exports